/*
 * Copyright (c) University of Technology Sydney. All rights reserved.
 * See LICENSE file in the project root for full license information.
 *
 * Project Name: wpt-frontend.
 * Author: Michael Diponio
 * Created: 04/05/2022
 */

import * as React from 'react';
import { Row, ValueCell } from '@/wpt-lib/pdf/common/Table';
import { View } from '@react-pdf/renderer';
import SubHeading from '@/wpt-lib/pdf/common/SubHeading';

const MandatoryTraining = ({ mandatoryTraining }: { mandatoryTraining: boolean | null }) => (
    <View style={{ paddingTop: 20 }}>
        <Row>
            <SubHeading level={2} text="Manadatory Training" />
        </Row>
        <Row>
            <ValueCell
                label=""
                value={`I have ${
                    mandatoryTraining ? '' : 'not '
                }completed all required mandatory training for this year.`}
            />
        </Row>
    </View>
);

export default MandatoryTraining;
